import { useState, useEffect } from 'react'

// Reads the cycle-tracker brain's scored panel from /api/cycle-panel (Layer 2,
// ADR-0046): headline assessment + per-node states + per-cell normalized reads,
// with ?series=1 sparkline arrays for the v3 Cycle screen.
//
// Returns { assessment, nodes, computedAt, loading }. `nodes` is a keyed map:
//   { [node]: { label, panel, signalRole, votesDiffusion, turning,
//               weaknessIndex, present, members: [{ key, label, levelPct,
//               slope, weaknessScore, turning, tooYoung, fresh, asOf,
//               severity, series, seriesFrom, weakensWhen }] } }
export function useCyclePanel() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    fetch('/api/cycle-panel?series=1')
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled) { setData(d?.assessment ? d : null); setLoading(false) } })
      .catch(() => { if (!cancelled) { setData(null); setLoading(false) } })
    return () => { cancelled = true }
  }, [])

  return {
    assessment: data?.assessment ?? null,
    nodes: data?.nodes ?? {},
    computedAt: data?.computed_at ?? null,
    hero: data?.hero ?? null, // pure-template sentence, computed live server-side
    read: data?.read ?? null, // latest weekly Read { week_of, state, body } | null
    staleness: data?.staleness ?? [], // cells past their data-age ceiling / baskets with dark legs
    loading,
  }
}
